import { render, staticRenderFns } from "./entityCusMerge.vue?vue&type=template&id=15bb0fd8&scoped=true&"
import script from "./entityCusMerge.vue?vue&type=script&lang=js&"
export * from "./entityCusMerge.vue?vue&type=script&lang=js&"
import style0 from "./entityCusMerge.vue?vue&type=style&index=0&id=15bb0fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bb0fd8",
  null
  
)

component.options.__file = "entityCusMerge.vue"
export default component.exports